import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Checkbox } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../store/slices/authSlice';
import api from '../../utils/api';

const LoginPage: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = async (values: any) => {
    setLoading(true);
    try {
      const response = await api.post('/api/auth/login', {
        email: values.email,
        password: values.password
      });

      if (response.data.success) {
        message.success('ログイン成功！');
        
        // 保存token和用户信息
        const { user, token } = response.data.data;
        localStorage.setItem('token', token);
        dispatch(loginSuccess(user));
        
        // 根据用户角色跳转
        if (user.role === 'super_admin' || user.role === 'company_admin') {
          navigate('/admin');
        } else if (user.role === 'store_manager') {
          navigate('/franchise');
        } else {
          navigate('/');
        }
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'ログイン失敗、再試行してください';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          borderRadius: 12
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 30 }}>
          <h1 style={{ color: '#1890ff', fontSize: 28, fontWeight: 'bold', margin: 0 }}>
            AES Mobility
          </h1>
          <p style={{ color: '#666', margin: '8px 0 0 0' }}>スマートモビリティサービスプラットフォーム</p>
        </div>

        <Form
          form={form}
          onFinish={handleLogin}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="email"
            label="メールアドレス"
            rules={[
              { required: true, message: 'メールアドレスを入力してください' },
              { type: 'email', message: '正しいメールアドレスを入力してください' }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="メールアドレスを入力"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="パスワード"
            rules={[{ required: true, message: 'パスワードを入力してください' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="パスワードを入力"
            />
          </Form.Item>

          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Checkbox>パスワードを記憶</Checkbox>
              <a href="#" style={{ color: '#1890ff' }}>パスワードを忘れましたか？</a>
            </div>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 48, fontSize: 16, marginBottom: 16 }}
            >
              ログイン
            </Button>
          </Form.Item>

          <Form.Item>
            <Button
              type="default"
              onClick={() => navigate('/register')}
              block
              style={{ height: 48, fontSize: 16 }}
            >
              新規登録
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 20, color: '#666', fontSize: 12 }}>
          <p>アカウントをお持ちでない方は、新規登録からご利用ください</p>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;